import React from 'react'
import ReactDOM from 'react-dom'

import Stats from './pages/Stats/Stats'

import './index.css'

ReactDOM.render(
  <React.StrictMode>
    <div className='header'>
    <div className='header-subwrapper default-container'>
      <div className='logo'>
        <img src="/header-logo.svg" alt="logo" />
      </div>
      <a href="https://beamex.exchange" rel="noreferrer" target="_self" style={{ textDecoration: 'none' }}>
        <div className="perps-link">
          Beamex
        </div>
      </a>
    </div>

    </div>
    <Stats />
  </React.StrictMode>,
  document.getElementById('root')
)
